<template>
  <div class="text-left m">
    <div class="row-fluid">
      <div class="col-12">
        <textarea
          rows="5"
          class="input-group"
          placeholder="描述您的需求内容"
          v-model="content"
        ></textarea>
      </div>
      <div class="col-12">
        <section class="img_box">
          <label class="label111">
            <input
              type="file"
              style="display: none"
              ref="adFile"
              @change="addChange"
              accept="image/png,image/jpeg"
            />
            <div class="imgsaas" v-if="editFile != ''">
              <img :src="editFile" alt="" style="width: 100%" />
            </div>
            <div class="imgsaas" v-else-if="assistance_file != 'undefined'">
              <img :src="assistance_file" alt="" style="width: 100%" />
            </div>
            <div class="add_btn" v-else></div>
          </label>
        </section>
      </div>
      <div
        class="col-12 row tt_x_10"
        @click="Jump()"
        style="padding-right: 0px"
      >
        <div class="col-6">
          <h5 class="f_bt_1" style="width: 295px">
            <span class="glyphicon glyphicon-map-marker glyphicon-a"></span>
            {{ location ? location : "所在位置" }}
          </h5>
        </div>
        <div class="col-6 text-right middle" style="padding-right: 0px">
          <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
        </div>
      </div>
      <div
        class="col-12 row tt_x_10"
        style="padding-right: 0px"
        @click="show3 = true"
      >
        <div class="col-6">
          <h5 class="f_bt_1">
            <span class="glyphicon glyphicon-yen glyphicon-a"></span> {{ Paid }}
          </h5>
        </div>
        <div class="col-6 text-right middle" style="padding-right: 0px">
          <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
        </div>
      </div>
      <p v-if="Paid == '有偿'" style="margin-left: 15px">
        有偿金额：<input
          class="z_15"
          type="text"
          placeholder="填写金额"
          name=""
          id=""
          v-model="money"
        />
      </p>
      <div
        class="col-12 row tt_x_10"
        style="padding-right: 0px"
        @click="show2 = true"
      >
        <div class="col-6">
          <h5 class="f_bt_1" style="width: 300px">
            <span class="glyphicon glyphicon-user glyphicon-a"></span> {{ name
            }}{{ information }}
          </h5>
        </div>
        <div class="col-6 text-right middle" style="padding-right: 0px">
          <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
        </div>
      </div>
      <div
        class="col-12 row tt_x_10"
        style="padding-right: 0px"
        @click="showPicker = true"
      >
        <div class="col-6">
          <h5 class="f_bt_1 w">
            <span class="glyphicon glyphicon-calendar glyphicon-a"></span>
            {{ value ? value : "希望时间" }}
          </h5>
        </div>
        <div class="col-6 text-right middle" style="padding-right: 0px">
          <h6><samp class="glyphicon glyphicon-chevron-right"></samp></h6>
        </div>
      </div>
      <!-- <div @click="showPicker = true">{{value}}</div> -->
      <van-popup v-model="showPicker" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择完整时间"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
        <!-- :columns-order="['year','month', 'day','hour','minute' ]" :formatter="formatter" -->
        <!-- <van-picker show-toolbar  /> -->
      </van-popup>
      <div class="col-12">
        <button class="submit_btn" @click="release">保存</button>
      </div>

      <div id="d_p"></div>
    </div>
    <div class="pop" @click="show2 = false" v-show="show2"></div>
    <div class="edit2" v-show="show2">
      <div class="tt_10 tt_x_10">
        <h4 class="text-left">联系方式</h4>
      </div>
      <input
        name="fname"
        class="left in"
        placeholder="请输入姓名"
        v-model="gender2"
      />
      <div style="height: 10px"></div>
      <input
        name="fname"
        class="left in"
        placeholder="请输入联系电话"
        v-model="gender1"
      />
      <p v-if="err2" style="color: red; margin: 0">手机号码不正确</p>
      <button @click="confirm2">确认</button>
    </div>
    <div class="pop" @click="show3 = false" v-show="show3"></div>
    <div class="edit1" v-show="show3">
      <div class="tt_10 tt_x_10">
        <h4 class="text-left">是否有偿服务</h4>
      </div>
      <div
        class="text"
        v-for="(item, index) in list"
        :key="index"
        @click="real(item)"
      >
        <label for="item" class="left"
          >{{ item
          }}<input
            type="radio"
            :id="item"
            class="right"
            :value="item"
            v-model="gender3"
        /></label>
      </div>
    </div>
    <pop :show5="showji" message="修改成功" @editshow="editshow" />
  </div>
</template>

<script>
import pop from "./popup.vue";
import "@/assets/js/rolldate.js";
import "@/assets/js/rolldate.min.js";
export default {
  data() {
    return {
      showPicker: false,
      showji: false,
      money: "",
      list: ["有偿", "无偿"],
      name: "姓名",
      Paid: "服务类型",
      content: "",
      gender: "",
      gender1: "",
      gender2: "",
      gender3: "",
      err2: false,
      show: false,
      show1: false,
      show2: false,
      show3: false,
      datetimeEmpty: "",
      // time: ,
      location: "所在位置",
      information: "联系方式",
      value: "",
      time: ["希望时间"],
      minTime: [2018, 1, 1, 0, 0],
      maxTime: [2030, 12, 30, 24, 60],
      showChinese: false,
      resetTime: [],
      type: null,
      editFile: "",
      editFiles: "",
      editFilesname: "",
      assistance_file: "",
      filename: "",
      center: [],
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
    };
  },
  components: {
    pop,
  },
  props: {},
  created() {},
  mounted() {
    this.$api
      .getAPI(
        "mutual/assistance/" +
          this.$route.query.id +
          "?appid=202108&type_id=3001",
        {
          openid: this.$api.getUserInfo().openid,
        }
      )
      .then((res) => {
        console.log(res.data.data.models);
        // this.list = res.data.data.models
        if (res.data.data.models.assistance_paid == 2) {
          this.Paid = "有偿";
          this.money = res.data.data.models.assistance_money;
        }
        if (res.data.data.models.assistance_paid == 1) {
          this.Paid = "无偿";
        }
        this.content = res.data.data.models.assistance_text;
        if (this.$route.query.name == undefined) {
          this.location = res.data.data.models.assistance_address;
          this.center = res.data.data.models.assistance_address_xy;
        }
        this.information = res.data.data.models.telephone;
        this.name = res.data.data.models.username;
        this.gender1 = this.information;
        this.gender2 = this.name;
        this.gender3 = this.Paid;
        this.value = res.data.data.models.assistance_time;
        this.assistance_file = res.data.data.models.assistance_file;
        if (this.$route.query.name != undefined) {
          // console.log(123);
          this.location = this.$route.query.name;
          this.center = this.$route.query.center;
          this.content = window.localStorage.getItem("content");
          this.Paid = window.localStorage.getItem("Paid");
          this.money = window.localStorage.getItem("money");
          this.information = window.localStorage.getItem("information");
          this.name = window.localStorage.getItem("name");
          this.value = window.localStorage.getItem("value");
          this.assistance_file = window.localStorage.getItem("assistance_file");
          window.localStorage.removeItem("content");
          window.localStorage.removeItem("Paid");
          window.localStorage.removeItem("money");
          window.localStorage.removeItem("information");
          window.localStorage.removeItem("name");
          window.localStorage.removeItem("value");
          window.localStorage.removeItem("assistance_file");
        }
      });
    // console.log(this.$route.query.name);

    // console.log(this.center);
    // console.log(this.$route.query.name);
    // this.$axios.get("app/mutual/assistance/?appid=202108&type_id=3001").then(res => {
    //   console.log(res);
    // })
  },
  methods: {
    Jump() {
      let ff = this.center;
      if (typeof ff == "string") {
        ff = ff.split(",");
      }
      // console.log(this.$route.query.id);
      this.$router.push({
        name: "location1",
        query: { id: this.$route.query.id, name: this.location, center: ff },
      });
      window.localStorage.setItem("content", this.content);
      window.localStorage.setItem("Paid", this.Paid);
      window.localStorage.setItem("money", this.money);
      window.localStorage.setItem("information", this.information);
      window.localStorage.setItem("name", this.name);
      window.localStorage.setItem("value", this.value);
      window.localStorage.setItem("assistance_file", this.assistance_file);
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
      this.value = this.timeFormat(this.value);
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      // console.log(time.getFullYear());
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let hour = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();
      return (
        year + "年" + month + "月" + day + "日" + hour + "时" + minute + "分"
      );
    },
    addChange(e) {
      console.log(e);
      console.log(this.$refs.adFile.files[0]);
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      console.log(file);
      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.editFile = res.result;
      };
      reader.readAsDataURL(file);
      this.editFiles = file;
      console.log(this.editFiles);
      let formData = new FormData();
      formData.append("fileName", this.editFiles);
      // console.log(this.avatar_url);
      this.$api.postAPI(`default/upload/?state=1`, formData).then((res) => {
        this.assistance_file = res.data.url;
        console.log(this.assistance_file);
      });
    },
    editshow() {
      this.showji = false;
      this.$router.push("/user_help_list");
    },
    release() {
      let data = new FormData();
      // console.log(this.Paid);
      if (this.Paid == "有偿") {
        data.append("assistance_paid", 2);
        data.append("assistance_money", this.money);
        // console.log(this.money);
      }
      if (this.Paid == "无偿") {
        data.append("assistance_paid", 1);
      }
      data.append("assistance_text", this.content);
      data.append("assistance_address", this.location);
      data.append("assistance_address_xy", this.center.join(","));
      data.append("telephone", this.information);
      data.append("assistance_time", this.value);
      data.append("username", this.name);
      data.append("assistance_file", this.assistance_file);
      //data.append('openid', window.localStorage.getItem('openid'))
      data.append("support_community_pass", 3);
      // data.append('openid', 2354414)
      this.$api
        .postAPI(
          `mutual/assistance/` +
            this.$route.query.id +
            `?appid=202108&type_id=3001&state=1`,
          data
        )
        .then((res) => {
          console.log(res);
          var socket = new WebSocket(
            "ws://dns1.hsnms.com:17072/web/join/?appid=0&openid=4&nickname=ceosgg"
          );
          //添加状态判断，当为OPEN时，发送消息
          var message = {
            openid: this.$api.getUserInfo().openid,
            assistance_address_xy: this.center,
            assistance_text: this.content,
            username: this.name,
            assistance_address: this.location,
            telephone: this.information,
            assistance_time: this.value,
            assistance_paid: this.Paid,
          };
          message = JSON.stringify(message);
          //添加事件监听
          socket.addEventListener("open", function () {
            socket.send(message);
          });
          this.$Message.success("发布成功，等待审核！");
          this.$router.push("/user_help_list");
          // this.showji = true
          // alert('修改成功')
        });
    },
    // confirm () {
    //   if (this.gender != "") {
    //     this.location = this.gender
    //   } else {
    //     this.location = '所在位置'
    //   }
    //   this.show = false
    // },
    confirm2() {
      if (this.gender1 != "") {
        this.information = this.gender1;
      } else {
        this.information = "联系方式";
      }
      if (!/^1[34578]\d{9}$/.test(this.gender1)) {
        this.err2 = 1;
        return false;
      } else {
        this.err2 = 0;
      }
      this.show1 = false;
      if (this.gender2 != "") {
        this.name = this.gender2;
      } else {
        this.name = "";
      }
      this.show2 = false;
    },
    real(item) {
      this.gender3 = item;
      this.Paid = item;
      this.show3 = false;
    },
  },
};
</script>


<style>
.edit2 {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  top: 50%;
  /* top: 70%; */
  transform: translate(-50%, -50%);
  width: 300px;
  height: 230px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 20px;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}

.edit2 button {
  height: 35px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: #01b2c2;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 20px auto 10px;
  /* margin-top: 25px; */
  text-align: center !important;
}

label {
  width: 100%;
  margin: 0;
}

.left {
  float: left;
  text-align: left;
}

.text {
  position: relative;
  padding: 0px 10px;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e0e0e0;
}

.right {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  margin: 0;
}

.m {
  margin-top: 30px;
  padding: 10px;
}

/* #app {
  margin-top: 40px;
} */
.in {
  border: 1px solid #e0e0e0;
  padding: 0 10px;
  outline: none;
  height: 35px;
  width: 100%;
}

.pop {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 99;
}

.edit1 {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  top: 50%;
  /* top: 70%; */
  transform: translate(-50%, -50%);
  width: 300px;
  height: 187px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 20px;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}

.edit1 button {
  height: 35px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: #01b2c2;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 20px auto 10px;
  /* margin-top: 25px; */
  text-align: center !important;
}

textarea {
  padding: 8px;
  border: 1px dashed #e5e5e5;
}

.w {
  width: 300px;
}

li {
  list-style: none;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.hide {
  display: none;
}

.title {
  font-size: 1.2em;
  line-height: 3.3em;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
}

.img_box {
  margin-top: 1em;
}

.img_box ul {
  overflow: hidden;
  padding-inline-start: 0px;
}

.img_box ul li {
  float: left;
  width: 30%;
  margin-right: 2.5%;
  margin-bottom: 1em;
  padding: 30% 0 0;
  position: relative;
  cursor: pointer;
}

.img_box ul li img {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
}

.img_box .label111 .add_btn {
  width: 80px;
  height: 80px;
  border: 1px dashed #e5e5e5;
  background: url(https://www.17sucai.com/preview/61021/2020-01-20/%E5%B8%A6%E7%BC%A9%E7%95%A5%E5%9B%BE%E7%9A%84%E5%9B%BE%E7%89%87%E4%B8%8A%E4%BC%A0/imgs/add.png)
    no-repeat 50% 50%;
  cursor: pointer;
}

.imgsa {
  border: 1px dashed #e5e5e5;
  padding: 5px 10px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.imgsaas {
  width: 80px;
  height: 80px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img_box ul .del {
  position: absolute;
  width: 25px;
  height: 25px;
  line-height: 20px;
  text-align: center;
  font-size: 1.5em;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  right: 0;
  top: 0;
  font-style: inherit;
  cursor: pointer;
}

.note {
  margin-top: 30px;
  padding: 0 3.3%;
}

.note header {
  font-weight: bold;
  font-size: 1.2em;
  line-height: 2.4em;
}

.note ul li {
  padding: 0.3em 0;
}

.success {
  font-size: 1.4em;
  text-align: center;
  margin: 4em 0 0;
}

.datePickerDemo .head {
  width: 100%;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background: #f60;
}

.datePickerDemo .demo span {
  flex-basis: 50%;
  font-size: 16px;
  line-height: 50px;
}

.datePickerDemo .demo {
  display: flex;
  justify-content: space-around;
  padding: 0 15px;
  border-bottom: 1px gray solid;
}

.datePickerDemo .demo .format {
  text-align: left;
}

.datePickerDemo .demo .show {
  text-align: right;
}

.datePickerDemo .demo1 {
  padding: 0 15px;
  border-bottom: 1px gray solid;
  font-size: 16px;
  line-height: 50px;
}

.datePickerDemo .demo1 .format {
  text-align: left;
}

.datePickerDemo .demo1 .show {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user_help_save.vue